/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100080 仕入先マスタメンテ
 */
import {
  B000111ShirebunNm1,
  B000111ShirebunNm2,
  B000111ShirebunNm3,
  B000111ShirebunNm4,
  B000111ShirebunNm5,
  B000130BumonNm,
  B000140ShainNmBumonCd,
  B100080Create,
  B100080HandleSetNm,
  B100080SanshoShire,
  B100080Shire,
  B100080Update,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SConfirmDialog,
  SDateField,
  SFileButton,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { B000170 } from "pages";
import { B000111 } from "pages/b000/B000111";
import { B000140 } from "pages/b000/B000140";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { date } from "services";
import { meishoKbn, mode } from "services/codes";
import { focusState, navigateTypeState, useFocus } from "states";
import {
  B100080Mode,
  getSCode,
  SakujoyoteiKbn,
  SCode,
  ShokuchiKbn,
} from "../../messages/codes";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  modeKbn: SCode;
  shireCd: string;
  sanshoShireCd: string;
  shireNm1: string;
  shireNm2: string;
  shireKana: string;
  shireNmr: string;
  shokuchiKbn: SCode;
  postCd: string;
  address1: string;
  address2: string;
  telNo: string;
  faxNo: string;
  shainCd: string;
  shainNm: string;
  bumonCd: string;
  bumonNm: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  sakujoyoteiKbn: SCode;
  shirebunCd1: string;
  shirebunNm1: string;
  shirebunCd2: string;
  shirebunNm2: string;
  shirebunCd3: string;
  shirebunNm3: string;
  shirebunCd4: string;
  shirebunNm4: string;
  shirebunCd5: string;
  shirebunNm5: string;
  version: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  modeKbn: getSCode(B100080Mode, "0"),
  shireCd: "",
  sanshoShireCd: "",
  shireNm1: "",
  shireNm2: "",
  shireKana: "",
  shireNmr: "",
  shokuchiKbn: getSCode(ShokuchiKbn, "0"),
  postCd: "",
  address1: "",
  address2: "",
  telNo: "",
  faxNo: "",
  shainCd: "",
  shainNm: "",
  bumonCd: "",
  bumonNm: "",
  torihikikaishiYmd: date(),
  torihikishuryoYmd: "99991231",
  sakujoyoteiKbn: getSCode(SakujoyoteiKbn, "0"),
  shirebunCd1: "",
  shirebunNm1: "",
  shirebunCd2: "",
  shirebunNm2: "",
  shirebunCd3: "",
  shirebunNm3: "",
  shirebunCd4: "",
  shirebunNm4: "",
  shirebunCd5: "",
  shirebunNm5: "",
  version: "",
};

const focusId = "B100080";

// B100080 仕入先マスタメンテ
export const B100080 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移の処理
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);

  // 活性設定
  // 新規モードかどうか
  const isNew = methods.watch("modeKbn")?.value === mode.shinki;

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  // モード変更時
  const handleChangeModeKbn = () => {
    if (isNew) {
      methods.reset();
      methods.reset({
        ...methods.getValues(),
        shireCd: "",
        sanshoShireCd: "",
      });
      methods.setValue("modeKbn", getSCode(B100080Mode, "1"));
    } else {
      methods.reset();
      methods.reset({
        ...methods.getValues(),
        shireCd: "",
        sanshoShireCd: "",
      });
    }
  };

  // 更新
  const handleClickUpdateButton = () => {
    // 新規の場合
    if (isNew) {
      B100080Create(methods)
        .then(() => {
          methods.reset();
          methods.reset({
            ...methods.getValues(),
            shireCd: "",
            sanshoShireCd: "",
          });
          // ↓これがあると完了メッセージが表示される
          methods.setValue("shireCd", "");
          setMsg(getClientMessage("B100080_001"));
        })
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
        });
    }
    // 更新の場合
    else {
      B100080Update(methods)
        .then(() => {
          methods.reset();
          methods.reset({
            ...methods.getValues(),
            shireCd: "",
            sanshoShireCd: "",
          });
          // ↓これがあると完了メッセージが表示される
          methods.setValue("shireCd", "");
          setMsg(getClientMessage("B100080_002"));
        })
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
        });
    }
  };

  // 担当者の変更
  const HandleChangeShainCd = async () => {
    // 同期させる
    (async () => {
      // 担当者名を取得
      await B000140ShainNmBumonCd(methods, navigate, setMsg);
      // 担当部門名を取得
      await B000130BumonNm(methods, navigate, setMsg);
    })();
  };

  // excelボタンクリック時
  const handleMoveOutput = () => {
    // 仕入先マスタ出力画面へ遷移する。
    setMenuNavigate("next");
    navigate("/b100083");
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="仕入先マスタメンテ"
          gridTemplateColumns="8rem 8rem 10rem 5rem 1rem 8rem 10rem 10rem"
        >
          <SText gridColumn="span 7"></SText>
          <SFileButton
            label={labels.buttons.excel}
            align="right"
            {...register(24)}
            onClick={handleMoveOutput}
          />

          <SLabel required gridColumn="1">
            モード
          </SLabel>
          <SCodeSelect
            name="modeKbn"
            label="モード"
            required
            options={B100080Mode}
            {...register(1)}
            onChange={() => handleChangeModeKbn()}
          />
          <SLabel required gridColumn="1">
            仕入先コード
          </SLabel>
          {isNew ? (
            <>
              <SNumberField
                name="shireCd"
                label="仕入先コード"
                code
                required
                size={6}
                {...register(2)}
              />
            </>
          ) : (
            <>
              <SNumberField
                name="shireCd"
                label="仕入先コード"
                code
                required
                size={6}
                dialog={<B000170 deljogaiKbn="1" />}
                handleSubmit={(data: any) => {
                  methods.setValue("shireCd", data.shireCd ?? "");
                  methods.setValue("shireNm1", data.shireNm1 ?? "");
                  methods.setValue("shireNm2", data.shireNm2 ?? "");
                  methods.setValue("shireKana", data.shireKana ?? "");
                  methods.setValue("shireNmr", data.shireNmr ?? "");
                  methods.setValue(
                    "shokuchiKbn",
                    getSCode(ShokuchiKbn, data.shokuchiKbn) ?? null
                  );
                  methods.setValue("postCd", data.postCd ?? "");
                  methods.setValue("address1", data.address1 ?? "");
                  methods.setValue("address2", data.address2 ?? "");
                  methods.setValue("telNo", data.telNo ?? "");
                  methods.setValue("faxNo", data.faxNo ?? "");
                  methods.setValue("shainCd", data.shainCd ?? "");
                  methods.setValue("shainNm", data.shainNm ?? "");
                  methods.setValue("bumonCd", data.bumonCd ?? "");
                  methods.setValue("bumonNm", data.bumonNm ?? "");
                  methods.setValue(
                    "torihikikaishiYmd",
                    data.torihikikaishiYmd ?? ""
                  );
                  methods.setValue(
                    "torihikishuryoYmd",
                    data.torihikishuryoYmd ?? ""
                  );
                  methods.setValue(
                    "sakujoyoteiKbn",
                    getSCode(SakujoyoteiKbn, data.sakujoyoteiKbn) ?? null
                  );
                  methods.setValue("shirebunCd1", data.shirebunCd1 ?? "");
                  methods.setValue("shirebunCd2", data.shirebunCd2 ?? "");
                  methods.setValue("shirebunCd3", data.shirebunCd3 ?? "");
                  methods.setValue("shirebunCd4", data.shirebunCd4 ?? "");
                  methods.setValue("shirebunCd5", data.shirebunCd5 ?? "");
                  methods.setValue("version", data.version ?? "");

                  // コードに紐づく名称の設定
                  B100080HandleSetNm(methods, navigate, setMsg);
                }}
                onBlur={() => B100080Shire(methods, navigate, setMsg)}
                {...register(2)}
              />
            </>
          )}
          <SLabel gridColumn={6}>参照コード</SLabel>
          <SNumberField
            name="sanshoShireCd"
            code
            disabled={!isNew}
            size={6}
            dialog={<B000170 deljogaiKbn="1" />}
            handleSubmit={(data: any) => {
              methods.setValue("sanshoShireCd", data.shireCd ?? "");
              methods.setValue("shireNm1", data.shireNm1 ?? "");
              methods.setValue("shireNm2", data.shireNm2 ?? "");
              methods.setValue("shireKana", data.shireKana ?? "");
              methods.setValue("shireNmr", data.shireNmr ?? "");
              methods.setValue(
                "shokuchiKbn",
                getSCode(ShokuchiKbn, data.shokuchiKbn) ?? null
              );
              methods.setValue("postCd", data.postCd ?? "");
              methods.setValue("address1", data.address1 ?? "");
              methods.setValue("address2", data.address2 ?? "");
              methods.setValue("telNo", data.telNo ?? "");
              methods.setValue("faxNo", data.faxNo ?? "");
              methods.setValue("shainCd", data.shainCd ?? "");
              methods.setValue("shainNm", data.shainNm ?? "");
              methods.setValue("bumonCd", data.bumonCd ?? "");
              methods.setValue("bumonNm", data.bumonNm ?? "");
              methods.setValue(
                "torihikikaishiYmd",
                data.torihikikaishiYmd ?? ""
              );
              methods.setValue(
                "torihikishuryoYmd",
                data.torihikishuryoYmd ?? ""
              );
              methods.setValue(
                "sakujoyoteiKbn",
                getSCode(SakujoyoteiKbn, data.sakujoyoteiKbn) ?? null
              );
              methods.setValue("shirebunCd1", data.shirebunCd1 ?? "");
              methods.setValue("shirebunCd2", data.shirebunCd2 ?? "");
              methods.setValue("shirebunCd3", data.shirebunCd3 ?? "");
              methods.setValue("shirebunCd4", data.shirebunCd4 ?? "");
              methods.setValue("shirebunCd5", data.shirebunCd5 ?? "");

              // コードに紐づく名称の設定
              B100080HandleSetNm(methods, navigate, setMsg);
            }}
            onBlur={() => B100080SanshoShire(methods, navigate, setMsg)}
            {...register(3)}
          />

          <SLabel required gridColumn="1">
            仕入先名1
          </SLabel>
          <STextField
            name="shireNm1"
            label="仕入先名1"
            required
            gridColumn="span 3"
            size={40}
            {...register(4)}
          />
          <SLabel gridColumn={6}>〒</SLabel>
          <STextField
            name="postCd"
            gridColumn="span 2"
            size={10}
            {...register(9)}
          />

          <SLabel gridColumn="1">仕入先名2</SLabel>
          <STextField
            name="shireNm2"
            gridColumn="span 3"
            size={40}
            {...register(5)}
          />
          <SLabel gridColumn={6}>住所1</SLabel>
          <STextField
            name="address1"
            gridColumn="span 2"
            size={40}
            {...register(10)}
          />

          <SLabel gridColumn="1">カナ名</SLabel>
          <STextField
            name="shireKana"
            gridColumn="span 3"
            size={40}
            {...register(6)}
          />
          <SLabel gridColumn={6}>住所2</SLabel>
          <STextField
            name="address2"
            gridColumn="span 2"
            size={40}
            {...register(11)}
          />

          <SLabel required gridColumn="1">
            略名
          </SLabel>
          <STextField
            name="shireNmr"
            label="略名"
            required
            size={24}
            gridColumn="span 2"
            {...register(7)}
          />
          <SLabel gridColumn={6}>TEL</SLabel>
          <STextField name="telNo" size={15} {...register(12)} />

          <SLabel required gridColumn="1">
            諸口
          </SLabel>
          <SCodeSelect
            name="shokuchiKbn"
            label="諸口"
            required
            options={ShokuchiKbn}
            {...register(8)}
          />
          <SLabel gridColumn={6}>FAX</SLabel>
          <STextField name="faxNo" size={15} {...register(13)} />

          <SLabel gridColumn="1" required>
            担当者
          </SLabel>
          <SNumberField
            name="shainCd"
            label="担当者コード"
            code
            required
            dialog={<B000140 />}
            handleSubmit={(data: any) => {
              methods.setValue("shainCd", data?.shainCd);
              methods.setValue("shainNm", data?.shainNm);
              methods.setValue("bumonCd", data?.bumonCd);
              B000130BumonNm(methods, navigate, setMsg);
            }}
            size={7}
            onBlur={() => HandleChangeShainCd()}
            {...register(14)}
          />
          <STextField name="shainNm" disabled gridColumn="span 2" />
          <SLabel gridColumn={6}>担当部門</SLabel>
          <STextField name="bumonNm" gridColumn="span 2" disabled />

          <SLabel required gridColumn={1}>
            取引開始年月日
          </SLabel>
          <SDateField
            name="torihikikaishiYmd"
            label="取引開始年月日"
            required
            {...register(15)}
          />
          <SLabel gridColumn={6} required>
            取引終了年月日
          </SLabel>
          <SDateField
            name="torihikishuryoYmd"
            label="取引終了年月日"
            required
            {...register(16)}
          />
          <SLabel gridColumn="1">削除予定区分</SLabel>
          <SCodeSelect
            name="sakujoyoteiKbn"
            options={SakujoyoteiKbn}
            {...register(17)}
          />
        </SFrame>

        <SFrame gridTemplateColumns="8rem 5rem 3rem 10rem">
          <SLabel gridColumn="span 4">仕入先分類</SLabel>
          <SLabel gridColumn="1">仕入先分類1</SLabel>
          <SNumberField
            name="shirebunCd1"
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.shirebun1} />}
            handleSubmit={(data: any) => {
              methods.setValue("shirebunCd1", data?.meishoCd);
              methods.setValue("shirebunNm1", data?.meishoNm1);
            }}
            onBlur={() => B000111ShirebunNm1(methods, navigate, setMsg)}
            {...register(18)}
          />
          <STextField name="shirebunNm1" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">仕入先分類2</SLabel>
          <SNumberField
            name="shirebunCd2"
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.shirebun2} />}
            handleSubmit={(data: any) => {
              methods.setValue("shirebunCd2", data?.meishoCd);
              methods.setValue("shirebunNm2", data?.meishoNm1);
            }}
            onBlur={() => B000111ShirebunNm2(methods, navigate, setMsg)}
            {...register(19)}
          />
          <STextField name="shirebunNm2" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">仕入先分類3</SLabel>
          <SNumberField
            name="shirebunCd3"
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.shirebun3} />}
            handleSubmit={(data: any) => {
              methods.setValue("shirebunCd3", data?.meishoCd);
              methods.setValue("shirebunNm3", data?.meishoNm1);
            }}
            onBlur={() => B000111ShirebunNm3(methods, navigate, setMsg)}
            {...register(20)}
          />
          <STextField name="shirebunNm3" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">仕入先分類4</SLabel>
          <SNumberField
            name="shirebunCd4"
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.shirebun4} />}
            handleSubmit={(data: any) => {
              methods.setValue("shirebunCd4", data?.meishoCd);
              methods.setValue("shirebunNm4", data?.meishoNm1);
            }}
            onBlur={() => B000111ShirebunNm4(methods, navigate, setMsg)}
            {...register(21)}
          />
          <STextField name="shirebunNm4" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">仕入先分類5</SLabel>
          <SNumberField
            name="shirebunCd5"
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.shirebun5} />}
            handleSubmit={(data: any) => {
              methods.setValue("shirebunCd5", data?.meishoCd);
              methods.setValue("shirebunNm5", data?.meishoNm1);
            }}
            onBlur={() => B000111ShirebunNm5(methods, navigate, setMsg)}
            {...register(22)}
          />
          <STextField name="shirebunNm5" disabled gridColumn="span 2" />
        </SFrame>

        <SFrame>
          <SNormalButton
            label={labels.buttons.update}
            align="right"
            {...register(23)}
            dialog={
              <SConfirmDialog
                title="マスタ更新"
                msg="更新します。よろしいですか？"
              />
            }
            dialogAction="confirm"
            handleSubmit={handleClickUpdateButton}
          />
        </SFrame>
      </FormProvider>
    </>
  );
};
